<template>
  <div class="container">
    <listFilter
      :formItems="filterItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    ></listFilter>
    <div class="tableWrap">
      <div class="leftButton">
        <CustomButton
          :permissionCode="authType.character.createRowAuth"
          type="primary"
          @click="createCharactor"
        >
          新建角色
        </CustomButton>
        <CustomButton
          :permissionCode="authType.character.exportTableAuth"
          type="warning"
          @click="exportFile"
        >
          导出
        </CustomButton>
      </div>
      <div class="tableBox">
        <Table
          class="nihao"
          border
          :columns="columns"
          size="small"
          stripe
          :data="dataSource"
          disabled-hover
          row-key="id"
          ref="tableRef"
        ></Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              show-total
              show-sizer
              :total="totalCount"
              :current="filter.pageIndex"
              :page-size="filter.pageSize"
              :page-size-opts="[10, 25, 50, 100]"
              @on-change="changePage"
              @on-page-size-change="pageSizeChange"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <!-- 蒙版弹出层 -->
    <Modal
      v-model="createCharactorModelStatus"
      :title="modalTitle"
      :loading="true"
      class="createModalClass"
    >
      <Form
        label-position="left"
        :label-width="90"
        :model="formValidate"
        ref="formValidate"
        :rules="ruleValidate"
      >
        <FormItem label="角色名称:" prop="roleName">
          <Input
            placeholder="请输入角色名称"
            v-model="formValidate.roleName"
          ></Input>
        </FormItem>
        <FormItem label="应用系统：" prop="appId">
          <Select v-model="formValidate.appId" :disabled="currentOpeate === 1">
            <Option
              v-for="item in appIdOptions"
              :value="item.value"
              :key="item.value"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="状态：" prop="roleStatus">
          <Select v-model="formValidate.roleStatus">
            <Option
              v-for="item in roleStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="角色描述:" prop="remark">
          <Input
            v-model="formValidate.remark"
            placeholder="请输入角色描述,最多200字"
            type="textarea"
            maxlength="200"
            show-word-limit
          ></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')"
            >确认</Button
          >
          <Button @click="popCreateMoal" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
    <Modal
      v-model="permissionmodalVisible"
      :title="rolePermissionTitle"
      :mask-closable="false"
      @on-cancel="permissionCancel"
      fullscreen
      :closable="false"
    >
      <PermissionSetting
        ref="permissionSettingRef"
        v-if="permissionmodalVisible"
        :roleId="currentRoleId"
        :currentAppId="passAppId"
      />
      <div slot="footer">
        <Button @click="permissionCancel">取消</Button>
      </div>
    </Modal>
    <PersonDialog
      :multiple="true"
      :roleId="currentRoleId"
      :roleName="currentRoleName"
      :visible.sync="personSettingModalVisible"
      @change="personSubmit"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import authType from '@/config/authType';
import { getListDropdown } from '@/api/appBase';
import { getOwnAppInAuthUserListApi } from '@/api/userManage';
import PermissionSetting from './components/PermissionSetting.vue';
import PersonSetting from './components/PersonSetting.vue';
import PersonDialog from './components/PersonDialog.vue';
import { filterItems, getColumns } from './components/config';
import util from '../../../assets/js/util';
const addCharactorURL = '/v1/role/add';
const editCharatorURL = '/v1/role/edit';

export default {
  name: 'charactorManagePage',
  mixins: [getPermissionMixin],
  data() {
    return {
      authType,
      show: true,
      // 当前的操作， 0是新建，1编辑
      currentOpeate: 0,
      message: '角色管理页面',
      twiceAlertStatus: false,
      system: '',
      // 当前的row的角色
      currentRowCharter: '',
      filterItems,
      filter: {
        pageSize: 10,
        roleStatus: -1,
        roleName: '',
        pageIndex: 1,
        roleId: '',
        appId: ''
      },
      passAppId: '',
      columns: [],
      // 弹窗的属性
      // 指示是否显示新建应用弹窗
      createCharactorModelStatus: false,
      // 通讯录选择器的list
      addressList: [],
      roleStatusList: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 }
      ],
      modalTitle: '新建角色',
      // 弹窗异步加载指示器
      // modalLoading: true,
      formValidate: {
        // 名称
        roleName: '',
        // 选择的状态
        roleStatus: 1,
        remark: '',
        appId: '',
        id: ''
      },
      ruleValidate: {
        roleName: [
          { required: true, message: '角色名称未填写', trigger: 'blur' }
        ],
        appId: [{ required: true, message: '请选择应用系统', trigger: 'change' }],
        roleStatus: [{ required: false }],
        remark: [{ required: false }]
      },
      permissionmodalVisible: false,
      currentRoleId: '',
      currentRoleName: '',
      personSettingModalVisible: false,
      appIdOptions: []
    };
  },
  computed: {
    ...mapState('characterManage', ['totalCount', 'dataSource']),
    rolePermissionTitle () {
      return this.currentRoleName ? `角色授权 - ${this.currentRoleName}` : '角色授权';
    }
  },
  components: {
    PermissionSetting,
    PersonDialog
    // PersonSetting
  },
  methods: {
    ...mapMutations('characterManage', ['SAVE_STATE']),
    ...mapActions('characterManage', [
      'getUserPermission',
      'getTableInfo',
      'deleteApp'
    ]),
    async permissionCancel () {
      const ref = this.$refs.permissionSettingRef;
      await ref.systemChange();
      this.permissionmodalVisible = false;
    },
    changePage(num) {
      this.filter.pageIndex = num;
      this.getTableInfo({ filter: this.filter });
    },
    pageSizeChange(size) {
      this.filter.pageSize = size;
      this.getTableInfo({ filter: this.filter });
    },
    refreshTable() {
      console.log(this.$refs.characterTable);
    },
    refreshCharterList() {
      this.getTableInfo({ filter: this.filter });
    },
    searchTableInfo() {
      this.filter.pageIndex = 1;
      this.refreshCharterList();
    },
    // 编辑角色
    editRole(row) {
      this.createCharactorModelStatus = true;
      this.currentOpeate = 1;
      this.changeAlertMenu(row);
    },
    changeAlertMenu(row) {
      if (this.currentOpeate == 1) {
        // 编辑
        this.modalTitle = '编辑角色';
        this.formValidate.roleName = row.roleName;
        this.formValidate.roleStatus = row.roleStatus;
        this.formValidate.remark = row.remark;
        this.formValidate.id = row.id;
        this.formValidate.appId = row.appId;
      } else if (this.currentOpeate == 0) {
        // 新建
        this.modalTitle = '新建角色';
        this.formValidate.roleName = '';
        this.formValidate.roleStatus = 1;
        this.formValidate.remark = '';
        this.formValidate.id = '';
        this.formValidate.appId = '';
      }
    },
    // 添加用户
    addUser(index) {
      console.log(index);
    },
    // 角色授权
    charactorauthorization(index) {
      console.log(index);
    },
    createCharactor() {
      this.createCharactorModelStatus = true;
      this.currentOpeate = 0;
      this.changeAlertMenu({});
    },
    exportFile() {
      util.fileDownload(this.$ajax, '/v1/role/export', this.filter, '角色管理');
    },
    resetTableInfo() {
      this.filter.roleName = '';
      this.filter.appId = '';
      this.filter.roleStatus = -1;
    },

    popCreateMoal() {
      this.createCharactorModelStatus = false;
    },
    // 删除用户
    deleteCharactor(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该角色？',
        loading: true,
        cancelText: '取消',
        onOk: () => {
          this.$ajax
            .post(`/v1/role/delete/${this.currentRowCharter.id}`)
            .then(res => {
              this.twiceAlertStatus = false;
              const { data, code } = res.data;
              if (code == 200) {
                this.$Modal.remove();
                this.refreshCharterList();
              } else {
                this.$Message.error(data.msg);
              }
            });
        }
      });
      this.currentRowCharter = row;
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const params = this.formValidate;
          this.$ajax
            .post(
              this.currentOpeate == 0 ? addCharactorURL : editCharatorURL,
              params
            )
            .then(res => {
              const { data } = res;
              console.log(data);
              if (data.code == 200) {
                this.$Message.success('操作成功');
                this.createCharactorModelStatus = false;
                this.refreshCharterList();
              } else {
                console.log('bushi 200');
                this.$Message.error(data.msg);
              }
            });
        } else {
          this.$Message.error('所填信息错误');
        }
      });
    },
    setPermission(row) {
      this.currentRoleName = row.roleName;
      this.currentRoleId = row.id;
      this.passAppId = row.appId;
      this.permissionmodalVisible = true;
    },
    openPersonSettingModal(row) {
      this.currentRoleName = row.roleName;
      this.currentRoleId = row.id;
      this.personSettingModalVisible = true;
    },
    personSubmit(auth) {
      const userAuths = auth.map(item => ({
        authStatus: item.authStatus ? 1 : 0,
        id: item.id
      }));
      this.$ajax
        .post('/v1/role/editUsers', {
          roleId: this.currentRoleId,
          userAuths
        })
        .then(res => {
          const { code } = res.data;
          if (code == 200) {
            this.personSettingModalVisible = false;
          }
        });
    },
    callBack(res) {
      const arr =
        res.tableDataColMap == null
          ? []
          : util.getFirstDataByObj(res.tableDataColMap) || [];
      const noShowArr = arr.map(item => item.colName);
      this.columns = getColumns(
        {
          editBtnClick: this.editRole,
          deleteBtnClick: this.deleteCharactor,
          userButtonClick: this.openPersonSettingModal,
          actAuthBtnClick: this.setPermission
        },
        noShowArr
      );
    },
    init () {
      getListDropdown({ pageIndex: 1, pageSize: 99999, appStatus: -1 }).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          const list = (data.records || []).map(i => ({ name: i.name, value: i.id }));
          const index = this.filterItems.findIndex(i => i.model === 'appId');
          const obj = this.filterItems[index];
          obj.options = [{ value: '', name: '全部' }, ...list];
          this.$set(this.filterItems, index, obj);
        }
      });
    }
  },
  mounted() {
    this.columns.forEach(element => {
      this.$set(element, 'align', 'center');
    });
    this.init();
    this.refreshCharterList();
  },
  watch: {
    createCharactorModelStatus(val) {
      if (val) {
        getOwnAppInAuthUserListApi().then(res => {
          const { code, data } = res.data;
          if (code === 200) {
            const appIdOptions = data.map(item => ({ value: item.id, name: item.name }));
            this.appIdOptions = [...appIdOptions];
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.container {
  position: relative;
  padding: 0 20px;
}
.header {
  font-size: 32px;
}
.headerRight {
  float: right;
}
.leftButton {
  display: inline-block;
  padding-bottom: 20px;
}
.leftButton button:nth-child(2) {
  margin-left: 15px;
}
.rightButton {
  float: right;
  padding: 30px 200px 30px 200px;
}
.rightButton button {
  margin-left: 30px;
}
.createModalClass /deep/ .ivu-modal-footer {
  padding: 0 !important;
}
</style>
